module.exports = __webpack_public_path__ + "img/WALK-SUPPORT-A-GAUCHE.e736c207.svg";